import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { FaInstagram, FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import { LOGO_DARK, SOCIALS } from "@/lib/brand";

const SOCIAL_ICONS = { instagram: FaInstagram, facebook: FaFacebookF, linkedin: FaLinkedinIn };

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-obsidian text-ivory relative grain">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 py-16 md:py-24 relative">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-4">
            <img src={LOGO_DARK} alt="SBS Properties" className="h-14 w-auto" />
          </div>
          <p className="mt-5 text-ivory/60 text-base leading-relaxed max-w-sm">
            Building the future of Mombasa and the Kenyan coast through expert property management, strategic sales, and premium rentals since 1952.
          </p>
          <div className="mt-6 flex items-center gap-3">
            {SOCIALS.map((s) => {
              const Icon = SOCIAL_ICONS[s.id];
              return (
                <a
                  key={s.id}
                  data-testid={`footer-social-${s.id}`}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="flex h-10 w-10 items-center justify-center border border-white/15 transition-all duration-300 hover:scale-110 hover:bg-white/5"
                  style={{ color: s.color }}
                >
                  <Icon className="h-5 w-5" />
                </a>
              );
            })}
          </div>
          <Link
            to="/contact"
            data-testid="footer-cta-btn"
            className="group mt-8 inline-flex items-center gap-2 border border-brand-gold/60 px-6 py-3 text-sm font-semibold text-brand-gold hover:bg-brand-gold hover:text-obsidian transition-colors duration-300"
          >
            Start a Conversation
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </Link>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs font-mono uppercase tracking-[0.25em] text-brand-gold font-bold">Explore</h4>
          <ul className="mt-5 space-y-3 text-ivory/70">
            <li><Link data-testid="footer-link-properties" to="/listings" className="hover:text-ivory transition-colors">All Properties</Link></li>
            <li><Link data-testid="footer-link-rent" to="/listings?status=rent" className="hover:text-ivory transition-colors">For Rent</Link></li>
            <li><Link data-testid="footer-link-sale" to="/listings?status=sale" className="hover:text-ivory transition-colors">For Sale</Link></li>
            <li><Link data-testid="footer-link-about" to="/about" className="hover:text-ivory transition-colors">About Us</Link></li>
            <li><Link data-testid="footer-link-news" to="/news" className="hover:text-ivory transition-colors">News & Insights</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-xs font-mono uppercase tracking-[0.25em] text-brand-gold font-bold">Contact</h4>
          <ul className="mt-5 space-y-4 text-ivory/70">
            <li className="flex items-start gap-3">
              <Phone className="h-4 w-4 mt-1 text-brand-gold shrink-0" />
              <a data-testid="footer-phone" href="tel:+254709746298" className="hover:text-ivory transition-colors">+(254) 709 746 298</a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="h-4 w-4 mt-1 text-brand-gold shrink-0" />
              <a data-testid="footer-email" href="mailto:info@sbsproperties.co.ke" className="hover:text-ivory transition-colors">info@sbsproperties.co.ke</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="h-4 w-4 mt-1 text-brand-gold shrink-0" />
              <span>SBS Markiti Complex, 1st Floor,<br />PO Box 81497-80100, Mombasa, Kenya</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-16 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-t border-white/10 pt-8">
        <p className="text-xs text-ivory/40">© {new Date().getFullYear()} SBS Properties.</p>
        <Link to="/admin/login" data-testid="footer-staff-link" className="text-xs text-ivory/40 hover:text-brand-gold transition-colors">
          Staff Portal
        </Link>
      </div>
    </div>
  </footer>
);
